// Packages

// Components

// Logic

// Context
import BtnListContainerContext from "./BtnListContainerContext";

// Services

// Styles

// Assets

export const BtnListContainer = ({ children }) => {
	return <BtnListContainerContext>{children}</BtnListContainerContext>;
};
